export interface LabeledOption { value: string; label: string; }

// Sortiert Optionen alphabetisch (deutsche Collation) nach label. Ein
// Platzhalter-Eintrag mit leerem value ("Alle"/"Ohne …"/"Kein …") bleibt immer
// an erster Stelle.
export function sortOptionsByLabel<T extends LabeledOption>(options: readonly T[]): T[] {
  const empty = options.filter((o) => o.value === '');
  const rest = options.filter((o) => o.value !== '').slice().sort((a, b) => a.label.localeCompare(b.label, 'de'));
  return [...empty, ...rest];
}
